import { useEffect, useState } from "react";
import { BLOG_POSTS } from "@/data/blogData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/blog`;

export const useBlogPosts = () => {
  const [posts, setPosts] = useState(BLOG_POSTS);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/posts`)
      .then((r) => (r.ok ? r.json() : []))
      .then((api) => {
        if (!alive || !Array.isArray(api) || !api.length) return;
        const known = new Set(BLOG_POSTS.map((p) => p.slug));
        setPosts([...api.filter((p) => !known.has(p.slug)), ...BLOG_POSTS]);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return posts;
};

export const useBlogPost = (slug) => {
  const local = BLOG_POSTS.find((p) => p.slug === slug) || null;
  const [post, setPost] = useState(local);
  const [loading, setLoading] = useState(!local);
  useEffect(() => {
    if (local) { setPost(local); setLoading(false); return undefined; }
    let alive = true;
    setLoading(true);
    fetch(`${API}/posts/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => { if (alive) { setPost(p); setLoading(false); } })
      .catch(() => { if (alive) { setPost(null); setLoading(false); } });
    return () => { alive = false; };
  }, [slug, local]);
  return { post, loading };
};
